import styled from 'styled-components';

export const RunContainer = styled.div.attrs({})`
  padding: 16px 0 0 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  min-width: min(520px, 80vw);
`;

export const LoadingBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 24px 0;
  font-size: 14px;
  color: #4a5568;
`;

// Um card por contador do resumo. O de envio fica em destaque; os que pedem
// trabalho do operador (sem telefone, falhas...) ganham a cor de atencao.
export const CounterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
`;

export const CounterCard = styled.div`
  border: 1px solid
    ${(props) =>
      props.$highlight ? '#2670D1' : props.$warning ? '#FF9500' : '#E2E8F0'};
  background: ${(props) =>
    props.$highlight ? '#2670D112' : props.$warning ? '#FF950012' : '#fff'};
  border-radius: 8px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const CounterValue = styled.strong`
  font-size: 22px;
  color: #2d3748;
`;

export const CounterLabel = styled.span`
  font-size: 12px;
  text-transform: uppercase;
  color: #718096;
`;

// O aviso e o motivo de a acao pedir confirmacao: ela manda WhatsApp para
// clientes reais e nao tem volta.
export const WarningBox = styled.div`
  background: #ff950012;
  border-left: 4px solid #ff9500;
  border-radius: 6px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const WarningTitle = styled.strong`
  font-size: 14px;
  color: #2d3748;
`;

export const WarningText = styled.span`
  font-size: 13px;
  color: #4a5568;
  line-height: 1.45;
`;

export const NoteBox = styled.div`
  background: #f7fafc;
  border-left: 4px solid #2670d1;
  border-radius: 6px;
  padding: 12px 14px;
  font-size: 13px;
  color: #4a5568;
  line-height: 1.45;
`;

export const ButtonContainer = styled.div.attrs({})`
  width: 100%;
  display: flex;
  gap: 16px;
  justify-content: flex-end;
`;
